
So I took a photo...

<br />

<a href="https://unsplash.com/@cdbattags?photo=BckPaTv1RZ8" target="_blank">
	<img src="/assets-cdbattaglia/media/blog-posts/people-tate-modern.webp" style={{width: "75%", height: "75%", display: "block", margin: "auto"}} />
</a>

<br />

...on a trip to London summer of 2014 during a week long break in my study abroad program. A group of me and 4 friends
set out to conquer London and Dublin but I booked my flight drunk and ended up in the Queen's country a day before
everyone else.

Turns out: solo travel is actually pretty fun. I arrived in Gatwick early morning, took the light rail to the city and
got off at the first stop. I decided I'd spend my time walking all the way up to Kings Cross towards my
[hostel](https://www.clinkhostels.com/london/clink78/). Backpack and all, I
[trekked](https://www.google.com/maps/dir/Westminster+Station,+Bridge+St,+London+SW1A+2JR,+UK/Buckingham+Palace,+London,+United+Kingdom/Shakespeare's+Globe,+New+Globe+Walk,+London,+United+Kingdom/King's+Cross+St.+Pancras,+Euston+Road,+London,+United+Kingdom/Clink78,+78+King's+Cross+Rd,+Kings+Cross,+London+WC1X+9QG,+UK/@51.5161122,-0.1369234,14z/data=!3m1!4b1!4m32!4m31!1m5!1m1!1s0x487604c449b45ed3:0x25f3edbdeb1538df!2m2!1d-0.1248313!2d51.5011487!1m5!1m1!1s0x48760520cd5b5eb5:0xa26abf514d902a7!2m2!1d-0.14189!2d51.501364!1m5!1m1!1s0x487604a905ae1621:0xe700778eb8b2878e!2m2!1d-0.097194!2d51.508076!1m5!1m1!1s0x48761b3c5cbf139b:0x7be9c9cf71db38fb!2m2!1d-0.1243105!2d51.531703!1m5!1m1!1s0x48761b4711dc7599:0xb29d1c5a036b6f5!2m2!1d-0.1155601!2d51.5287762!3e2)
over to Buckingham Palace, across to the Globe and finally wound my way up through the city towards Kings Cross.

Got to the hostel around 5pm and thought to myself, "hmmm, what now?". Found my way to my (16 person) room and
I ended up meeting an Australian just out of university, travelling the world. I believe he was from Perth (if this ever
finds you, friend, hi!) and he was about to take a shower but was wondering if I wanted to meet him down at the basement
bar for  a drink. I farted around for a bit unpacking and locking up the important stuff and then made my way downstairs.

<br />

<audio controls style={{display: "block", margin: "auto"}}>
  <source src="/assets-cdbattaglia/media/blog-posts/2014-06-07_Floor-Noise-Elevator-UK.m4a" type="audio/mp3" />
	Your browser does not support the audio element.
</audio>

<br />

Sat down at the bar and the cheeky "tender" starts toying with me as I ask for a good local brew. He said he was in
school for design but that bartending is his day job and told me a few stories about all the different folks
he's met there at the hostel. I go to take a sip of my drink and he looks at me like I'm stupid and says something
like "You can't just drink it straight off. You've got to pay first." Now I've never seen this guy again but holy hell
this has stuck with me for years. Every time I order a drink now I always give at least proof of payment before I take
any sip.

It was here I met Matt from San Francisco, a couple of British ladies (1 in the army and another a flight attendant)
who were celebrating a birthday and finally the Australian roommate and a few other folks he had met. We all went to
dinner just down the street for burgers and then back to the basement bar since it turns into a club at night.

The DJ was unlike anything I had ever heard. His transitions were sooooo good. If only I had taken some note of his
name. If you ever read this, man... Plz, plz get in touch.

<br />
<audio controls style={{display: "block", margin: "auto"}}>
  <source src="/assets-cdbattaglia/media/blog-posts/2014-06-07_Clash-Bar.m4a" type="audio/mp3" />
	Your browser does not support the audio element.
</audio>
<br />

Not really the [all the way up](https://www.youtube.com/watch?v=y2ak_oBeC-I) sort of vibe there but you get my drift.

Mr. Idris Elba the fashionista bartender pouring me drinks and bonding heavy with Matt from SF, I'm dancing my heart out.
Well so party lasts until late and we head to the clubs (some drum and bass spot near Kings Cross) and we go til about 6 in the morning.
_Clamouring_ home and my way upstairs into my 16 person room, I wake almost everyone up climbing into my top bunk and head straight to bed.

Wake up the next morning still a bit dazed and only thing on my mind is food and water. Where I come across none other than...
Matt from SF again with his new buddy Jeff Masters the travelling doctor from Australia! I'm meeting my friends late that afternoon on
the flight I was originally supposed to have booked but I have plenty of time to kill til then. We decide to hit up the Tate.

It was here after the first few floors we encounter the rooftop bar. I'm stunned. The wide open windows are just gorgeous and the way the
folks are taking in the view after just having taken in the art... Glorious. We're just about to leave when it hits me
"why am I not taking photos rn?!?". And thus, snap.

### Uploading, tagging and the likes

I get home at the end of the week and go to upload my photos together and I'm stunned again by the simple-ness of what
I took there at the Tate Modern. So much so that I use it as my first foray into [Unsplash](http://unsplash.com).
And so luck me, they just implemented the "tagging" feature where I can add searchable tags to my photo. Knowing
what this means, I spend a good 15 minutes coming up with a massive list of relative terms, upload and then go about
my regular business.

The success:

- featured on the home page
- tons of likes

And as of today, it has been viewed over 2 million times... Unbelievable.

Just look how many articles have used it since: https://goo.gl/NOPiv7

So there's my story. The photo that started it all. Am I a photographer now?

### About the site

Unsplash markets itself as "free (do whatever you want) high-resolution photos."

_**Do whatever you want**_, here, means:

> All photos published on Unsplash are licensed under Creative Commons Zero which means you can copy, modify,
> distribute and use the photos for free, including commercial purposes,
> without asking permission from or providing attribution to the photographer or Unsplash.
